import _ from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import AddProduct from "./addProduct";
import UpdateProduct from "./addProduct/Update";
import classes from "./index.module.css";
import ProductLogs from "./ProductLogs";
import ProductReportFilter from "./ProductReportFilter";
import ProductReportSummary from "./ProductReportSummary";
import SelectModal from "./SelectModal";
import { useSelector } from "react-redux";
import { displayToast } from "../../framework/toast/toastUtils";

const Products = () => {
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [showUpdateProduct, setShowUpdateProduct] = useState(false);
  const [productId, setProductId] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [showLogs, setShowLogs] = useState(false);
  // const [filterParams, setFilterParams] = useState(null);
  const [filterStates, setFilterStates] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isDownload, setIsDownload] = useState(false);

  const { data } = useSelector(
    (state) => state.commonReducer.tabs[state.commonReducer?.activeTabIndex]
  );

  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();
  const updateRef = useRef();
  const logRef = useRef();
  const refreshRef = useRef();
  const addRef = useRef();
  const uploadRef = useRef();
  const downloadRef = useRef();

  const refreshData = useCallback((filterData = {}) => {
    reportRef.current.applyFilters(filterData);
  }, []);

  const uploadData = useCallback(() => {
    setShowModal(true);
    setIsDownload(false);
  }, []);

  const downloadData = useCallback(() => {
    setShowModal(true);
    setIsDownload(true);
  }, []);

  const addProduct = useCallback((isEdit = false) => {
    if (isEdit) {
      setProductId(reportRef.current.getCurrentRowData()?.medicineId);
    }
    setShowAddProduct(true);
    setShowUpdateProduct(false);
  }, []);

  const updateProduct = useCallback(() => {
    setShowUpdateProduct(true);
    setShowAddProduct(false);
  }, []);

  const closeShowLogsAC = useCallback(() => {
    setCurrentComponent("grid_reports");
    setShowLogs(false);
    setProductId(null);
  }, [setCurrentComponent, setShowLogs]);

  const logHandler = useCallback(() => {
    setProductId(reportRef.current.getCurrentRowData()?.medicineId);
    setShowLogs(true);
  }, [setShowLogs]);

  const closeProductAc = useCallback(() => {
    setShowAddProduct(false);
    setShowUpdateProduct(false);
    setProductId(null);
    setCurrentComponent("grid_reports");
    refreshData();
  }, [setCurrentComponent, refreshData]);

  const debounceCloseProductAc = _.debounce(closeProductAc, 200);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const listener = useCallback((e) => {
    const key = e.key?.toLowerCase();
    const ctrlKey = e.ctrlKey;
    const altKey = e.altKey;
    if (altKey && key === "r") {
      refreshRef.current.click();
      return;
    }
    if (altKey && key === "u") {
      uploadRef.current.click();
      return;
    }
    if (altKey && key === "d") {
      downloadRef.current.click();
      return;
    }
    if (ctrlKey && key === "m") {
      return addRef.current.click();
    }
    if (ctrlKey && key === "e") {
      return editRef.current.click();
    }
    if (ctrlKey && key === "u") {
      return updateRef.current.click();
    }
    if (key === "enter") {
      return logRef.current.click();
    }
  }, []);

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          addProduct(true);
        }}
        isAccessible={currentRowData}
      />,
      <Button
        ref={updateRef}
        startIcon={<Shortcut keys={["Ctrl", "U"]} />}
        label="Update Details"
        onClick={() => {
          if (data?.rows?.filter((item) => item.checked).length >= 1) {
            updateProduct();
          } else {
            displayToast({
              type: "error",
              title: "Please select at least one medicine to update.",
            });
            return false;
          }
        }}
        isAccessible={currentRowData}
      />,
      <Button
        ref={logRef}
        label="View Log"
        startIcon={<Shortcut keys={["Enter"]} />}
        onClick={logHandler}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [currentRowData, addProduct, updateProduct, logHandler, data?.rows]);

  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddProduct &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow, showAddProduct]);
  useEffect(() => {
    refreshData({ isFilterChanged: true, ...filterStates });
  }, [refreshData, filterStates]);
  return (
    <>
      <div className={classes["product-report-container"]}>
        <Reports
          identifier="product"
          reportRef={reportRef}
          rowLevelCTAs={rowLevelCTAs}
          onFilterShowClick={setOnFilterShow}
          onColumnShowClick={setOnColumnShow}
          currentRow={(data) => {
            setCurrentRowData(data);
          }}
          filters={
            <ProductReportFilter
              reportRef={reportRef}
              filters={(filters) => {
                setFilterStates(filters);
              }}
              // refreshData={refreshData}
              // applyFilters={(params, filterStates) => {
              //   // refreshData(params);
              //   // setFilterParams(params);
              //   // setFilterStates(filterStates);
              // }}
              onFilterShow={onFilterShow}
            />
          }
        />
        <ProductReportSummary
          refreshData={refreshData}
          refreshRef={refreshRef}
          addRef={addRef}
          uploadRef={uploadRef}
          uploadData={uploadData}
          downloadRef={downloadRef}
          downloadData={downloadData}
          showAutoComplete={() => {
            addProduct();
          }}
        />
        <Autocomplete
          show={showAddProduct}
          height="82%"
          width="90%"
          closeAutoComplete={debounceCloseProductAc}
        >
          <AddProduct
            editProductId={productId}
            showAddProduct={showAddProduct}
            onEscape={debounceCloseProductAc}
            onSave={debounceCloseProductAc}
          />
        </Autocomplete>
        <Autocomplete
          show={showUpdateProduct}
          height="85%"
          width="100%"
          closeAutoComplete={debounceCloseProductAc}
        >
          <UpdateProduct
            productData={data?.rows?.filter((item) => item.checked)}
            onEscape={debounceCloseProductAc}
            onSave={debounceCloseProductAc}
          />
        </Autocomplete>
        <Autocomplete
          show={showLogs}
          height="60%"
          width="90%"
          closeAutoComplete={closeShowLogsAC}
        >
          <ProductLogs id={productId} onEscape={closeShowLogsAC} />
        </Autocomplete>
      </div>
      <SelectModal
        showModal={showModal}
        onClose={closeModal}
        onEscape={closeModal}
        isDownload={isDownload}
        reportRef={reportRef}
      />
    </>
  );
};

export default Products;
